export const LOCALES = {
    ENGLISH: 'en',
    RUSSIAN: 'ru'
};
